// extracted by mini-css-extract-plugin
export default {"container":"ContentBox_container__8V4pY","box":"ContentBox_box__mjpBU","img":"ContentBox_img__xLjcs","text":"ContentBox_text__OVPVU"};